import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";

import TouchPad from '../TouchPad/TouchPad';

const topic = props => (
    <TouchPad
        spinnerState={props.spinnerState}
        topic={props.selectedTopic}
        closeApp={() => props.closeApp()}
        setBlocksLocation={currentTopicId => props.setBlocksLocation(currentTopicId)}
        resetBlocksLocation={currentTopicId => props.resetBlocksLocation(currentTopicId)}
        allBlocks={props.allBlocks}
        startNewQuiz={props.startNewQuiz}
    />
);

topic.propTypes = {
    topics: PropTypes.array,
};

const mapStateToProps = state => ({
    selectedTopic: state.topicListReducer.selectedTopic
});

export default connect(mapStateToProps)(topic);